"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingFormulaTotalForTrip = exports.pricingFormulaTotal = exports.pricingFormulaSubtotalWithMinimum = exports.pricingFormulaSubtotal = exports.pricingFormulaDeserialize = void 0;
const round_1 = __importDefault(require("lodash/round"));
const Coupon_1 = require("../controllers/Coupon");
const PricingFormula_1 = require("../controllers/PricingFormula");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const Coupon_2 = require("./Coupon");
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const PricingFormulaItem_1 = require("./PricingFormulaItem");
const Trip_1 = require("./Trip");
const deserializeMinimum = (value) => (0, deserializeNumber_1.deserializeNumber)(value, 0);
function pricingFormulaDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        name: (0, deserializeString_1.deserializeString)(object.name),
        items: (0, deserializeArray_1.default)(PricingFormulaItem_1.pricingFormulaItemDeserialize)(object.items),
        minimumD: (0, unwrap_1.default)(object.minimumD, deserializeMinimum),
    };
}
exports.pricingFormulaDeserialize = pricingFormulaDeserialize;
// ------------------------------------------------------------------------------------------------------------ //
// subtotal
function pricingFormulaSubtotal(formula, charge, miles, minutes, tip, revenue) {
    let valueD = 0;
    const relvantItems = formula.items.filter(item => (0, PricingFormulaItem_1.pricingFormulaItemIsRelevant)(item, charge, miles, minutes, tip, revenue));
    for (const item of relvantItems) {
        valueD += (0, PricingFormulaItem_1.pricingFormulaItemTotal)(item, charge, miles, minutes, tip, revenue);
    }
    return valueD;
}
exports.pricingFormulaSubtotal = pricingFormulaSubtotal;
// subtotal with minimum
function pricingFormulaSubtotalWithMinimum(formula, charge, miles, minutes, tip, revenue) {
    let valueD = pricingFormulaSubtotal(formula, charge, miles, minutes, tip, revenue);
    if (formula.minimumD && valueD < formula.minimumD) {
        // console.log(`Increasing $${valueD} total to $${formula.minimumD} minimum`);
        valueD = formula.minimumD;
    }
    return valueD;
}
exports.pricingFormulaSubtotalWithMinimum = pricingFormulaSubtotalWithMinimum;
// total
function pricingFormulaTotal(type, formula, charge, miles, minutes, tip, revenue, coupon) {
    let valueD = pricingFormulaSubtotalWithMinimum(formula, charge, miles, minutes, tip, revenue);
    // apply coupon if any
    if (type == 'invoice' && coupon) {
        valueD = (0, Coupon_2.couponValue)(coupon, valueD);
    }
    switch (type) {
        case 'invoice': {
            valueD = (0, round_1.default)(valueD, 2);
            break;
        }
        case 'payout': {
            valueD = (0, round_1.default)(valueD, 0);
            break;
        }
    }
    // console.log(`Total: $${valueD}\n----------`);
    return valueD;
}
exports.pricingFormulaTotal = pricingFormulaTotal;
async function pricingFormulaTotalForTrip(type, trip, database, firestore) {
    const formula = await (0, PricingFormula_1.pricingFormulaForTrip)(type, trip, database, firestore);
    const { charge, miles, minutes, tip, revenue } = (0, Trip_1.tripPricingFormulaInputValues)(trip);
    const coupon = await (0, unwrap_1.default)(trip.couponCode, code => (0, Coupon_1.couponRead)(code, database));
    return pricingFormulaTotal(type, formula, charge, miles, minutes, tip, revenue, coupon);
}
exports.pricingFormulaTotalForTrip = pricingFormulaTotalForTrip;
// async calculateForTrip(trip: Trip): Promise<number> {
//     // charge
//     const charge = trip.orderValue ?? 0
//     // try getting miles/minutes from trip
//     let miles = trip.estimatedMiles ?? false
//     let minutes = trip.estimatedMinutes ?? false
//     // fetch directions?
//     const locations = tripLocationsWithDefault(trip)
//     if (miles === false || minutes === false) {
//         if (locations.includes(null as never)) {
//             throw new Error('Locations array includes null')
//         } else if (locations.length < 2) {
//             miles = 0
//             minutes = 0
//         } else {
//             const directions = await GoogleApis.instance.maps.api.directions.json.getForTrip(trip)
//             const leg = directions?.data.routes[0].legs[0]
//             miles = round((leg.distance.value * Constants.kilometersPerMile) / 1000, 2)
//             minutes = round(leg.duration.value / 60, 2)
//         }
//     }
//     // add wait time to minutes
//     for (const location of locations) {
//         if (location && location.waitTimeS) {
//             minutes += location.waitTimeS / 60
//         }
//     }
//     // tip
//     const tip = trip.tip ?? 0
//     // revenue
//     const revenue = (trip.estimate ?? 0) + (trip.tip ?? 0) // revenue
//     // go!
//     return formula.calculate(charge, miles, minutes, tip, revenue)
// }
// static withId = async (collection: string, id: string) => {
//     const snapshot = await admin.firestore().collection(collection).doc(id).get()
//     return snapshot.exists ? new PricingFormula(snapshot.data() as never) : undefined
// }
// static fetch = async (
//     formulaIdPropertyName: string,
//     collection: string,
//     uid?: string,
//     pickupCoordinatesArray?: CoordinatesArray,
//     pickupName?: string,
//     tripSource?: TripSource,
//     tripType?: TripType,
//     vendorId?: string
// ) => {
//     // console.log({
//     //     formulaIdPropertyName,
//     //     collection,
//     //     uid,
//     //     pickupCoordinatesArray,
//     //     pickupName,
//     //     tripSource,
//     //     tripType,
//     //     vendorId
//     // })
//     // try by user ID
//     const snapshot =
//         uid && (await admin.database().ref('users').child(uid).child(formulaIdPropertyName).once('value'))
//     if (snapshot && snapshot.exists()) {
//         console.log(`Using formula "${snapshot.val()}" for user "${uid}"`)
//         return await PricingFormula.withId(collection, snapshot.val())
//     }
//     // try by place
//     const placeSnapshot =
//         pickupCoordinatesArray && (await Place.nearCoordinatesArray(pickupCoordinatesArray))
//     if (placeSnapshot && placeSnapshot.get(formulaIdPropertyName)) {
//         console.log(
//             `Using formula ${placeSnapshot.get(formulaIdPropertyName)} for place "${placeSnapshot.get('name') || '??'
//             }"`
//         )
//         return await PricingFormula.withId(collection, placeSnapshot.get(formulaIdPropertyName))
//     }
//     // try by vendor
//     const vendor = vendorId
//         ? await Vendor.withId(vendorId)
//         : pickupName
//             ? await unwrap(await Vendor.vendorIdForName(pickupName), id => Vendor.withId(id))
//             : undefined
//     if (vendor && (vendor as never)[formulaIdPropertyName]) {
//         console.log(
//             `Using formula "${(vendor as never)[formulaIdPropertyName]}" for vendor "${vendor.name}"`
//         )
//         return await PricingFormula.withId(collection, (vendor as never)[formulaIdPropertyName])
//     }
//     // try by trip source
//     const tripSourceDetail = tripSource && (await TripSourceDetail.fetch(tripSource))
//     if (tripSourceDetail && tripSourceDetail[formulaIdPropertyName]) {
//         console.log(
//             `Using formula "${tripSourceDetail[formulaIdPropertyName]}" for trip source "${tripSource}"`
//         )
//         return await PricingFormula.withId(collection, tripSourceDetail[formulaIdPropertyName])
//     }
//     // try by trip type
//     const tripTypeDetail = await TripTypeDetail.fetch(tripType)
//     if (tripTypeDetail && tripTypeDetail[formulaIdPropertyName]) {
//         console.log(
//             `Using formula "${tripTypeDetail[formulaIdPropertyName]}" for trip type "${tripType}"`
//         )
//         return await PricingFormula.withId(collection, tripTypeDetail[formulaIdPropertyName])
//     }
//     // fall back to rideshare (only if system hasn't been set up properly)
//     const rideshareTripTypeDetail = await TripTypeDetail.withId(TripTypeModel.scoopM.rawValue)
//     if (!rideshareTripTypeDetail || !rideshareTripTypeDetail[formulaIdPropertyName]) {
//         throw new Error(
//             'Pricing formulas are not set up. You at least need one for "scoopM". Also add driver payout formula(s)'
//         )
//     }
//     console.log(
//         `Falling back to formula "${rideshareTripTypeDetail[formulaIdPropertyName]}" for default trip type "${TripTypeModel.scoopM.rawValue}"`
//     )
//     return await PricingFormula.withId(collection, rideshareTripTypeDetail[formulaIdPropertyName])
// }
